import React from 'react';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Header from 'components/Header';
import LoanDialog from 'components/Loans/LoanDialog';
import { fetchLoansByOrg } from '/actions/loans';
import { dollars } from 'utils/money';
import { isEmpty } from 'lodash';
import { date } from 'utils/date';

class Loans extends React.Component {
  componentWillMount = () => {
    const { organisation, dispatch } = this.props;
    dispatch(fetchLoansByOrg(organisation.id));
  }

  renderLoansTable = () => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Loan number</TableCell>
            <TableCell>Principal</TableCell>
            <TableCell>Application fee</TableCell>
            <TableCell>Term length</TableCell>
            <TableCell>Drawdown date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.props.loans && this.renderLoans()}
        </TableBody>
      </Table>
    );
  }

  renderLoans = () => {
    const { loans } = this.props;
    return loans.map(loan => (
      <TableRow key={loan.id}>
        <TableCell>
          <LoanDialog
            loan={loan}
            buttonLabel={loan.loanNumber}
          />
        </TableCell>
        <TableCell>
          {dollars(loan.principal)}
        </TableCell>
        <TableCell>
          {dollars(loan.establishmentFee)}
        </TableCell>
        <TableCell>
          {`${loan.termLength} ${loan.termUnit}`}
        </TableCell>
        <TableCell>
          { date(loan.drawdownDate) }
        </TableCell>
      </TableRow>
    ));
  }

  render = () => {
    const { fetching } = this.props;
    return (
      <div>
        <Header heading='Loans' />
        <ListItem>
          {
            fetching
            ? <CircularProgress size={50} />
            : isEmpty(this.props.loans)
              ? 'N/A'
              : this.renderLoansTable()
          }
        </ListItem>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const orgId = ownProps.organisation.id;
  const { loans } = state.organisations[orgId];
  const { fetching } = state.quotes;
  return { loans, fetching };
};

const reduxed = connect(mapStateToProps)(Loans)
export default withStyles({})(reduxed)



// WEBPACK FOOTER //
// ./src/components/Organisations/Loans.js